import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LockBox, PendingLockBox, TableColumn } from 'src/app/models/model';
import { AppNavigationHeaderComponent } from '../../components/navigation-header/app-navigation-header.component';
import { CardsComponent } from '../../components/cards/cards.component';
import { DeviceAlertsComponent } from './device-alerts/device-alerts-main-tab.component';
import { MatIconButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { DeviceMapHomeComponent } from './device-map-home/device-map-home.component';
import { DeviceNotesHomeComponent } from './device-notes-home/device-notes-home.component';
import { AnalyticsTrackingService } from '../../services/analytics-tracking.service';

const NAMES: string[] = [
	'1518 Central Ave., Middletown, OH 45044',
	'9558 Civic Centre Blvd., West Chester, OH 45069',
	'5353 Dixie Hwy., Fairfield, OH 45014',
	'1335 Main St., Hamilton, OH 45013',
	'4 W. State St., Trenton, OH 45067',
	'3533 Roosevelt Blvd., Middletown, OH 45044',
	'2267 Millville Ave., Hamilton, OH 45013',
	'120 S. Locust St., Oxford, OH 45056',
	'1051 Eaton Ave., Hamilton, OH 45013',
	'7967 Cincinnati Dayton Rd., West Chester, OH 45069',
];

@Component({
	selector: 'app-home',
	host: {
		class: 'app-home',
	},
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss', '../common/main.scss'],
	imports: [
		AppNavigationHeaderComponent,
		CardsComponent,
		DeviceAlertsComponent,
		MatIconButton,
		MatMenuTrigger,
		MatIcon,
		MatMenu,
		MatMenuItem,
		DeviceMapHomeComponent,
		DeviceNotesHomeComponent,
	],
})
export class HomeComponent implements OnInit {
	private readonly analytics = inject(AnalyticsTrackingService);

	pendingLockBoxes!: any;
	pendingLockBoxesTableColumns!: TableColumn[];

	lockBoxes!: any;
	lockBoxesTableColumns!: TableColumn[];

	propertiesChartOptionData: any;
	missingKeysChartOptionData: any;

	constructor(private router: Router) {
		const pendingLockBoxes = Array.from({ length: 10 }, (_, k) =>
			createPendingLockbox(k + 1)
		);
		const lockBoxes = Array.from({ length: 10 }, (_, k) =>
			createLockbox(k + 1)
		);
		this.pendingLockBoxes = pendingLockBoxes;
		this.lockBoxes = lockBoxes;
	}

	ngOnInit(): void {
		this.analytics.logEvent('screen_view', {
			firebase_screen: 'Dashboard',
			firebase_screen_class: 'HomeComponent',
		});

		this.initPendingLockBoxesColumn();
		this.initLockBoxesColumns();
		this.setChartOptions();
		this.setKeyOptions();
	}

	initPendingLockBoxesColumn(): void {
		this.pendingLockBoxesTableColumns = [
			{ header: 'ID', dataKey: 'id' },
			{ header: 'Installation Date', dataKey: 'install_date' },
			{ header: 'Name', dataKey: 'name' },
		];
	}

	initLockBoxesColumns(): void {
		this.lockBoxesTableColumns = [
			{ header: 'ID', dataKey: 'id' },
			{ header: 'Battery Percentage', dataKey: 'progress' },
			{ header: 'Name', dataKey: 'name' },
		];
	}

	setChartOptions(): void {
		const options = {
			xAxis: {
				type: 'category',
				data: [
					'Jan',
					'Feb',
					'Mar',
					'Apr',
					'May',
					'Jun',
					'Jul',
					'Aug',
					'Sep',
					'Oct',
					'Nov',
					'Dec',
				],
			},
			yAxis: {
				type: 'value',
			},
			series: [
				{
					data: [
						120,
						{
							value: 200,
							itemStyle: {
								color: '#a90000',
							},
						},
						300,
						50,
					],
					type: 'bar',
				},
			],
		};

		this.propertiesChartOptionData = options;
	}

	setKeyOptions(): void {
		const options = {
			xAxis: {
				type: 'category',
				data: [
					'Jan',
					'Feb',
					'Mar',
					'Apr',
					'May',
					'Jun',
					'Jul',
					'Aug',
					'Sep',
					'Oct',
					'Nov',
					'Dec',
				],
			},
			yAxis: {
				type: 'value',
			},
			series: [
				{
					data: [150, 230],
					type: 'line',
				},
			],
		};

		this.missingKeysChartOptionData = options;
	}

	refreshDeviceMap() {
		this.router.navigate([this.router.url]);
	}
}

function createPendingLockbox(id: number): PendingLockBox {
	const name = NAMES[Math.round(Math.random() * (NAMES.length - 1))];

	return {
		id: id.toString(),
		name,
		install_date: randomDate(new Date(2021, 2, 1), new Date()),
	};
}

function createLockbox(id: number): LockBox {
	const name = NAMES[Math.round(Math.random() * (NAMES.length - 1))];
	const progress: number = Math.round(Math.random() * 100);

	return {
		id: id.toString(),
		name,
		progress: `${progress}%`,
	};
}

function randomDate(start: Date, end: Date): string {
	return new Date(
		start.getTime() + Math.random() * (end.getTime() - start.getTime())
	).toLocaleString('en-US');
}
